import dynamic from 'next/dynamic'
import { Hooks } from '@microfrontends/react-components'
import { TNotificationProps } from './type'

const DynamicNotification = dynamic<any>(
	import('@microfrontends/react-components').then((mod) => mod.Notifications),
	{ ssr: false }
)

export default function NotificationComponent(props: TNotificationProps) {
	Hooks.useInitNotification()

	return (
		<DynamicNotification
			langCode={props.langCode}
			user={props.user}
			config={{
				firebaseConfig: props.firebaseConfig,
				jobSeekerUrl: props.jobSeekerUrl,
				baseMsUrl: process.env.MICROSERVICE_DOMAIN ?? ''
			}}
		/>
	)
}
